import axios from 'axios';

const axiosInstance = axios.create({
  // baseURL: 'https://backend.aprovatotal.com.br/api/backend/v2'
  baseURL: process.env.REACT_APP_API_URL + '/api/backend/v2'
});

export default axiosInstance;